export const namespaced = true;

export const state = {
  presets: [
    {
      name: "All",
    },
    {
      name: "Default",
      active: [
        "Group",
        "links",
        "GroupType",
        "Assignee",
        "ID",
        "Group Status",
        "Domain",
        "Subdomain",
        "Updated by",
        "Created",
        "Updated",
        //lower Level
        "Link Status",
        "Link",
        "Domain Status",
        "Subdomain Status",
        "Anchor Text",
        "Pre Text",
        "Title Tag",
        "Page Topic",
      ],
    },
    {
      name: "None",
    },
  ],
  active: null,
};

export const mutations = {
  SET_ACTIVE_COLUMNS(state, val) {
    state.active = val;
    localStorage.setItem("columnVisibility", JSON.stringify(state.active));
  },
};

export const actions = {
  setActiveColumns({ commit }, val) {
    commit("SET_ACTIVE_COLUMNS", val);
  },
};
